module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/breeno-phone-1.56177a24.png";